var keyIngredients = function () {

    var publicMethods = {};

    // Selectors object
    var selectors = {
        hoverItems: document.querySelectorAll(".hover-item"),
        viewMoreIngredients: document.querySelector('[data-view-more-ingredients]'),
        keyIngredientsGrid: document.querySelector('[data-key-ingredients-grid]')
    };
    
    let hoverItems = function(){

        selectors.hoverItems.forEach(hoverItem => {
            hoverItem.addEventListener("click", function (e){
                console.log('click');

                selectors.hoverItems.forEach(trigger => {
                    if(e.target.closest('.hover-item') !== trigger){
                        trigger.classList.remove('is--active');
                    }
                })
                this.classList.toggle('is--active');

            })
            
        });
    }
    let viewMoreIngredients = function(){
        selectors.viewMoreIngredients.addEventListener("click", (e) => {

            let self = e.target;
            let text = e.target.textContent.toLowerCase();
            console.log(text);

            if( text == 'view more' ){
                self.textContent = 'View Less';
                selectors.keyIngredientsGrid.classList.add('show--all');
            }else{
                self.textContent = 'View More';
                selectors.keyIngredientsGrid.classList.remove('show--all');
            }
        });
    }

    hoverItems();
    viewMoreIngredients();
}();
